<main class="survey-admin user-voice" role="main" aria-label="User voice - submit ideas">
  <header class="survey-admin__header">
    <h1 class="survey-admin__title">User voice</h1>
    <p class="survey-admin__desc">Submit ideas for how we can improve the survey system. Your feedback helps us prioritize features and fixes.</p>
  </header>

  <section class="user-voice__submit" aria-labelledby="submit-idea-heading">
    <h2 id="submit-idea-heading" class="user-voice__section-title">Submit an idea</h2>
    <form class="survey-form" role="form" (ngSubmit)="submit()" id="user-voice-form">
      <div class="survey-form__group">
        <label class="survey-form__label" for="user-voice-title">Title <span class="survey-form__required" aria-hidden="true">*</span></label>
        <input
          class="survey-form__input survey-form__input--wide"
          type="text"
          id="user-voice-title"
          required
          maxlength="500"
          placeholder="Short summary of your idea"
          [(ngModel)]="title"
          name="title"
          aria-required="true"
        />
        <p class="survey-form__hint">Maximum 500 characters.</p>
      </div>
      <div class="survey-form__group">
        <label class="survey-form__label" for="user-voice-content">Details (optional)</label>
        <textarea
          class="survey-form__textarea"
          id="user-voice-content"
          rows="5"
          placeholder="Describe your idea, use case, or suggestion in more detail..."
          [(ngModel)]="content"
          name="content"
        ></textarea>
      </div>
      @if (submitError) {
        <p class="survey-form__error" role="alert">{{ submitError }}</p>
      }
      @if (submitSuccess) {
        <p class="user-voice__success" role="status" aria-live="polite">Thank you. Your idea has been submitted.</p>
      }
      <div class="survey-form__actions">
        <button type="submit" class="btn btn-primary" [disabled]="submitting" [attr.aria-busy]="submitting">
          {{ submitting ? 'Submitting...' : 'Submit idea' }}
        </button>
      </div>
    </form>
  </section>

  <section class="user-voice__list" aria-labelledby="ideas-list-heading">
    <h2 id="ideas-list-heading" class="user-voice__section-title">Submitted ideas</h2>
    @if (loading) {
      <p role="status" aria-live="polite">Loading...</p>
    } @else if (ideas.length === 0) {
      <p class="survey-form__hint">No ideas submitted yet.</p>
    } @else {
      <ul class="user-voice__ideas-list" role="list">
        @for (idea of ideas; track idea.id) {
          <li class="user-voice__idea-item">
            <div class="user-voice__idea-header">
              <strong class="user-voice__idea-title">{{ idea.title }}</strong>
              <span class="user-voice__idea-status" [attr.data-status]="idea.status">{{ idea.status }}</span>
            </div>
            @if (idea.content) {
              <p class="user-voice__idea-content">{{ idea.content }}</p>
            }
            <p class="user-voice__idea-meta">Submitted {{ idea.createdAt | date:'short' }}</p>
          </li>
        }
      </ul>
    }
  </section>
</main>
